<div class="pt-4">
    <div v-if="loaded">
        <b-alert :show="isLive" variant="danger">
            <strong>Live credentials spend real money.</strong> Purchases are charged to your Umbai wallet, so fund your wallet before you start trading.
        </b-alert>

        <div v-if="!credentials">
            <p v-if="isLive">Create your live credentials when your integration is ready for production.</p>
            <p v-else>Create your test credentials to start building. You get R1,000 of test funds, and test purchases never move real money.</p>
            <b-button :variant="isLive ? 'danger' : 'primary'" :disabled="isLoading" @click="generate">
                Create {{ isLive ? 'live' : 'test' }} credentials
            </b-button>
        </div>

        <div v-else>
            <div v-if="!isLive" class="d-flex justify-content-between align-items-center border rounded p-3 mb-4">
                <div>
                    <small class="text-muted d-block">Test balance</small>
                    <h4 v-if="balance" class="mb-0">R{{ balance.balance.toFixed(2) }}</h4>
                    <span v-else class="text-muted">{{ balanceFailed ? 'Unavailable right now' : 'Loading...' }}</span>
                </div>
                <b-button variant="outline-primary" size="sm" @click="loadBalance">Refresh</b-button>
            </div>

            <b-alert :show="fundsFailed" variant="warning">
                Your test funds could not be added. Regenerate your secret to try again.
            </b-alert>

            <b-alert :show="!!secret" variant="info">
                <b-icon icon="info-circle-fill" class="mr-2"></b-icon><strong>Copy your client secret now.</strong> We don't store it, so you won't be able to see it again.
            </b-alert>

            <b-form-group label="Identity URL:">
                <b-input-group>
                    <b-form-input :value="credentials.identityUrl" readonly></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="copy(credentials.identityUrl)">Copy</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <b-form-group label="Gateway URL:">
                <b-input-group>
                    <b-form-input :value="credentials.gatewayUrl" readonly></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="copy(credentials.gatewayUrl)">Copy</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <b-form-group label="Client ID:">
                <b-input-group>
                    <b-form-input :value="credentials.clientId" readonly></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="copy(credentials.clientId)">Copy</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>

            <b-form-group label="Client Secret:">
                <b-input-group v-if="secret">
                    <b-form-input :value="secret" readonly></b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-primary" @click="copy(secret)">Copy</b-button>
                    </b-input-group-append>
                </b-input-group>
                <b-form-input v-else value="Hidden, regenerate it if you have lost it" readonly></b-form-input>
            </b-form-group>

            <b-button variant="outline-danger" class="mb-4" :disabled="isLoading" @click="regenerate">Regenerate secret</b-button>

            <hr />
            <h6>Postman</h6>
            <p class="text-muted">Import both files, select the Umbai {{ isLive ? 'Live' : 'Test' }} environment, and run Authentication first.</p>
            <b-button variant="primary" class="mr-2 mb-2" href="/postman/umbai-api.postman_collection.json" download>Download collection</b-button>
            <b-button variant="primary" class="mb-2" @click="downloadEnvironment">Download environment</b-button>
            <p v-if="!secret"><small class="text-muted">The environment file leaves the secret blank, so add it in Postman.</small></p>
        </div>
    </div>
    <div class="vld-parent">
        <loading :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"></loading>
    </div>
</div>
